<template>
    <div>
        <div class="row">
            <div class="col-12 px-0">
                <ul class="qf-dashboard-navigation">
                    <li :class="{'qf-active-nav' :activeTab === 'details'}">
                        <a href="#!"
                           @click.prevent="changeTab('details')">{{$ml.get('Trademark_Details')}}</a>
                    </li>
                    <li :class="{'qf-active-nav' :activeTab === 'files'}">
                        <a href="#!"
                           @click.prevent="changeTab('files')">{{$ml.get('Files')}}
                            <span class="small">({{brand.documents?brand.documents.length:0}})</span></a>
                    </li>
                    <li></li>
                </ul>
            </div>
        </div>
        <div class="row">
            <div class="col-12 pb-3">
                <a href="/dashboard" @click.prevent="$router.back()" class="small">&lt;&nbsp;{{$ml.get('Back')}}</a>
            </div>
        </div>
        <div class="row" v-if="loading">
            <div class="col-12 text-center h2 pt-5">
                <font-awesome-icon icon="spinner" size="2x" class="fa-spin"/>
            </div>
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-12">
                    <div class="d-flex align-items-center">
                        <div class="qf-mw-100px">
                            <img :src="`${$store.state.baseUrl}${brand.logo_path}`" alt="logo" class="img-fluid"
                                 v-if="brand.logo_path.length">
                            <img src="../../assets/img/placeholders/logo.png" alt="logo" class="img-fluid" v-else>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" v-if="activeTab==='details'">
                <div class="col-12">
                    <div class="row">
                        <div class="col-12 small">
                            <div class="d-flex flex-column flex-md-row align-items-stretch">
                                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                                    <div class="py-3 pl-3 w-50">
                                        <trade-mark-icon height="16" width="16"
                                                         class="qf-va-sub mr-2"></trade-mark-icon>
                                        {{$ml.get('Trademark')}}
                                    </div>
                                    <div class="py-3 pr-3 w-50"><strong>{{brand.brand_name}}</strong></div>
                                </div>
                                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                                    <div class="py-3 pl-3 w-50">
                                        <tracked-by-icon height="18" width="18"
                                                         class="qf-va-sub mr-2"></tracked-by-icon>
                                        {{$ml.get('Tracked_by')}}
                                    </div>
                                    <div class="py-3 pr-3 w-50">
                                        <div class="list-inline-item" v-for="(item, index) in trackedBy" :key="index">
                                            <strong>{{$ml.get(item)}}</strong>
                                            <span v-if="index !== (trackedBy.length -1)">, </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex flex-column flex-md-row align-items-stretch">
                                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                                    <div class="py-3 pl-3 w-50">
                                        <kind-icon height="16" width="16" class="qf-va-sub mr-2"></kind-icon>
                                        {{$ml.get('Type')}}
                                    </div>
                                    <div class="py-3 pr-3 w-50"><strong>{{brand.type}}</strong></div>
                                </div>
                                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                                    <div class="py-3 pl-3 w-50">
                                        <status-icon height="18" width="18" class="qf-va-sub mr-2"></status-icon>
                                        {{$ml.get('Status')}}
                                    </div>

                                    <div class="py-3 pr-3 w-50"><strong>{{brand.status ?
                                        $ml.get(`status_${brand.status}`) :
                                        ''}}</strong></div>
                                </div>
                            </div>
                            <div class="d-flex flex-column flex-md-row align-items-stretch">
                                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                                    <div class="py-3 pl-3 w-50">
                                        <number-of-request-icon height="18" width="18"
                                                                class="qf-va-sub mr-2"></number-of-request-icon>
                                        {{$ml.get('Application_Number')}}
                                    </div>
                                    <div class="py-3 pr-3 w-50"><strong>{{brand.application_number}}</strong>
                                    </div>
                                </div>
                                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                                    <div class="py-3 pl-3 w-50">
                                        <registration-date-icon height="15" width="15"
                                                                class="qf-va-sub mr-2"></registration-date-icon>
                                        {{$ml.get('Application_Date')}}
                                    </div>
                                    <div class="py-3 pr-3 w-50"><strong>{{brand.application_date | dateFormat}}</strong>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex flex-column flex-md-row align-items-stretch">
                                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                                    <div class="py-3 pl-3 w-50">
                                        <registration-number-icon height="15" width="15"
                                                                  class="qf-va-sub mr-2"></registration-number-icon>
                                        {{$ml.get('Registration_Number')}}
                                    </div>
                                    <div class="py-3 pr-3 w-50"><strong>{{brand.register_number}}</strong></div>
                                </div>
                                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                                    <div class="py-3 pl-3 w-50">
                                        <registration-date-icon height="15" width="15"
                                                                class="qf-va-sub mr-2"></registration-date-icon>
                                        {{$ml.get('Date_Of_Registration')}}
                                    </div>
                                    <div class="py-3 pr-3 w-50"><strong>{{brand.registration_date |
                                        dateFormat}}</strong></div>
                                </div>
                            </div>
                            <div class="d-flex flex-column flex-md-row align-items-stretch">
                                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                                    <div class="py-3 pl-3 w-50">
                                        <registration-date-icon height="15" width="15"
                                                                class="qf-va-sub mr-2"></registration-date-icon>
                                        {{$ml.get('Create_Date')}}
                                    </div>
                                    <div class="py-3 pr-3 w-50"><strong>{{brand.created_at | dateFormat}}</strong></div>
                                </div>
                                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                                    <div class="py-3 pl-3 w-50">
                                        <registration-date-icon height="15" width="15"
                                                                class="qf-va-sub mr-2"></registration-date-icon>
                                        {{$ml.get('Update_Date')}}
                                    </div>
                                    <div class="py-3 pr-3 w-50"><strong>{{brand.updated_at | dateFormat}}</strong></div>
                                </div>
                            </div>
                            <div class="d-flex flex-column flex-md-row align-items-stretch">
                                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                                    <div class="py-3 pl-3 w-50">
                                        <owner-icon height="18" width="18" class="qf-va-sub mr-2"></owner-icon>
                                        {{$ml.get('Owner')}}
                                    </div>
                                    <div class="py-3 pr-3 w-50"><strong>{{brand.owner.name}}</strong></div>
                                </div>
                                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                                    <div class="py-3 pl-3 w-50">
                                        <owner-address-icon height="17" width="17"
                                                            class="qf-va-sub mr-2"></owner-address-icon>
                                        {{$ml.get('Owners_Address')}}
                                    </div>
                                    <div class="py-3 pr-3 w-50"><strong>{{brand.owner.address}}</strong></div>
                                </div>
                            </div>
                            <div class="d-flex flex-column flex-md-row align-items-stretch">
                                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                                    <div class="py-3 pl-3 w-50">
                                        <vienna-classes-icon height="16" width="16"
                                                           class="qf-va-sub mr-2"></vienna-classes-icon>
                                        {{$ml.get('Vienna_Classes')}}
                                    </div>
                                    <div class="py-3 pr-3 w-50">
                                        <div class="list-inline-item"
                                             v-for="(vienna_class, index) in brand.vienna_classes" :key="index">
                                            <a href="#!"
                                               @click.prevent v-b-tooltip.hover
                                               :title="vienna_class.description"
                                               class="qf-tooltip">
                                                <strong>{{vienna_class.class_id}}</strong>
                                            </a>
                                            <span v-if="index !== (brand.vienna_classes.length -1)">, </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                                    <div class="py-3 pl-3 w-50">
                                        <nice-classes-icon height="18" width="18"
                                                           class="qf-va-sub mr-2"></nice-classes-icon>
                                        {{$ml.get('Nice_Classes')}}
                                    </div>
                                    <div class="py-3 pr-3 w-50">
                                        <div class="list-inline-item" v-for="(nice_class, index) in brand.nice_classes"
                                             :key="index">
                                            <a href="#!"
                                               @click.prevent="showModal(nice_class.class_num)"
                                               ref="btnShow"><strong>{{nice_class.class_num}}</strong></a><span
                                                v-if="index !== (brand.nice_classes.length -1)">, </span>
                                              <b-modal :id="nice_class.class_num" hide-footer>
                                                    <div class="d-block">{{ nice_class.description }}</div>
                                              </b-modal>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex flex-column flex-md-row align-items-stretch">
                                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                                    <div class="py-3 pl-3 w-50 d-flex align-items-center">
                                        <department-icon height="17" width="17"
                                                         class="qf-va-sub mr-2"></department-icon>
                                        {{$ml.get('Country_Of_Origin')}}
                                    </div>
                                    <div class="py-3 pr-3 w-50"><strong>{{countryOfOrigin}}</strong></div>
                                </div>
                                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                                    <div class="py-3 pl-3 w-50">
                                        <protection-icon height="16" width="16"
                                                         class="qf-va-sub mr-2"></protection-icon>
                                        {{$ml.get('Expiration_Date')}}
                                    </div>
                                    <div class="py-3 pr-3 w-50"><strong>{{brand.expired_on | dateFormat}}</strong></div>
                                </div>
                            </div>
                            <div class="d-flex flex-column flex-md-row align-items-stretch">
                                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                                    <div class="py-3 pl-3 w-50">
                                        <number-of-request-icon height="18" width="18"
                                                                class="qf-va-sub mr-2"></number-of-request-icon>
                                        {{$ml.get('Designated_countries')}}
                                    </div>
                                    <div class="py-3 pr-3 w-50">
                                        <div class="list-inline-item"
                                             v-for="(country, index) in brand.designated_country" :key="index">
                                            <a href="#!"
                                               @click.prevent v-b-tooltip.hover
                                               :title="country"
                                               class="qf-tooltip">
                                                <strong>{{country}}</strong>
                                            </a>
                                            <span v-if="index !== (brand.designated_country.length -1)">, </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                                    <div class="py-3 pl-3 w-50">
                                        <colors-icon height="18" width="18" class="qf-va-sub mr-2"></colors-icon>
                                        {{$ml.get('Colors')}}
                                    </div>
                                    <div class="py-3 pr-3 w-50"><strong>{{brand.colors}}</strong></div>
                                </div>
                            </div>
                            <div class="d-flex flex-column flex-md-row align-items-stretch">
                                <div class="w-100 m-1 d-flex">
                                    <div class="py-3 pl-3 qf-w-10 qf-notes-label">
                                        <notes-icon height="18" width="18" class="qf-va-sub mr-2"></notes-icon>
                                        {{$ml.get('notes')}}
                                    </div>
                                    <div class="py-3 pr-3 qf-w-90 font-italic text-justify qf-white-space-pre-line" v-html="brand.note"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                         <div class="col pb-3 flex-grow-0">
                            <router-link :to="{ path: '/dashboard/oppositions', query: { 'earlierTrademark': brand.brand_name } }"
                                         class="btn btn-dark text-uppercase pr-4">
                                <font-awesome-icon icon="search"/>&nbsp;&nbsp;&nbsp;{{$ml.get('browse_oppositions_for_tm')}}
                            </router-link>
                        </div>
                        <div class="col pb-3 flex-grow-0">
                            <router-link :to="{name: 'Reports', params: {owner: brand.owner.id, brand: id }}"
                                         class="btn btn-dark text-uppercase pr-4">
                                <font-awesome-icon icon="search"/>&nbsp;&nbsp;&nbsp;{{$ml.get('Browse_Reports_For_TM')}}
                            </router-link>
                        </div>
                        <div class="col pb-3 flex-grow-0">
                            <a href="#!" class="btn btn-outline-dark pr-4"
                               @click.prevent="deleteBrand(id)"
                               v-if="user.roles[0] === 'ROLE_MAIN'">
                                        <span v-if="loadingDelete"><font-awesome-icon icon="spinner"
                                                                                      class="fa-spin"/></span>
                                <span v-else><font-awesome-icon icon="trash-alt"/>&nbsp;&nbsp;&nbsp;{{$ml.get('Delete')}}</span>
                            </a>
                        </div>
                        <div class="col pb-3 flex-grow-0">
                            <a href="#!" class="btn btn-warning pr-4"
                               @click.prevent="goToEdit"
                               v-if="user.roles[0] === 'ROLE_MAIN' || user.roles[0] === 'ROLE_WRITE'">
                                <font-awesome-icon icon="pen"/>&nbsp;&nbsp;&nbsp;{{$ml.get('Edit')}}</a>
                        </div>
                    </div>
                </div>
            </div>
            <brand-files :files="brand.documents"
                         :id="id" @addFile="addFile"
                         :brand="brand"
                         @removeFile="removeFile"
                         v-else></brand-files>
        </div>

    </div>
</template>

<script>
    import BrandFiles from './brands/BrandFiles'

    export default {
        name: "BrandDetails",
        components: {
            BrandFiles
        },
        props: {
            id: String
        },
        data() {
            return {
                brand: {},
                activeTab: 'details',
                loading: true,
                loadingDelete: false
            }
        },
        computed: {
            user() {
                return this.$store.state.loggedUser
            },
            trackedBy() {
                let tracked_by = [];
                if (this.brand.track_nice) {
                    tracked_by.push('Nice_Classes')
                }
                if (this.brand.track_title) {
                    tracked_by.push('Title')
                }
                if (this.brand.track_vienna) {
                    tracked_by.push('Vienna_Classes')
                }
                return tracked_by
            },
            countryOfOrigin() {
                if (this.brand.office_of_origin !== '') {
                    let result = this.$countries.find(obj => {
                        return obj.code.toLowerCase() === this.brand.office_of_origin.toLowerCase()
                    });
                    return result.name
                } else {
                    return ''
                }
            }
        },
        mounted() {
            this.$store.dispatch('brandDetails', this.id).then(response => {
                this.brand = response;
                this.loading = false
            });
            this.$store.dispatch('tags');
        },
        methods: {
            addFile(file) {
                let fileIndex = this.brand.documents.findIndex(obj => {
                    return obj.id === file.id
                });
                if (fileIndex === -1) {
                    this.brand.documents.push(file);
                } else {
                    this.brand.documents.splice(fileIndex, 1, file)
                }
                this.$store.dispatch('tags');
            },
            removeFile(fileId) {
                let fileIndex = this.brand.documents.findIndex(obj => {
                    return obj.id === fileId;
                });
                if (fileIndex !== -1) {
                    this.brand.documents.splice(fileIndex, 1);
                }
            },
            goToEdit() {
                this.$store.commit('setCurrentBrand', this.brand);
                this.$router.push({name: 'EditBrand', id: this.brand.id.toString()})
            },
            changeTab(tabName) {
                this.activeTab = tabName;
            },
            deleteBrand(id) {
                if (!this.loadingDelete) {
                    this.loadingDelete = true;
                    this.$store.dispatch('deleteBrand', id).then(response => {
                        if (response) {
                            this.$router.push({name: 'BrandReports'});
                            this.loadingDelete = false;
                        }
                    });
                }
            },
            showModal(modalName) {
                this.$root.$emit('bv::show::modal', modalName, '#btnShow')
            }
        }
    }
</script>

<style scoped>
    .qf-notes-label {
        min-width: 130px;
    }

    .qf-bg-white.w-50 {
        width: auto !important;
    }

    @media (min-width: 576px) {
    }

    @media (min-width: 768px) {
        .qf-bg-white.w-50 {
            width: 50% !important;
        }
    }
</style>
